import http from "../http-common";

const getAll = () => {
  return http.get("/users");
};

const get = (id) => {
  return http.get(`/users/user/${id}`);
};

const create = (data) => {
  return http.post("/users", data);
};

const update = (id, data) => {
  return http.put(`/users/user/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/users/user/${id}`);
};

const UserManagementService = {
  getAll,
  get,
  create,
  update,
  remove,
};

export default UserManagementService;

